<template>
  <section id="loginPage" class="is-medium">
    <div class="columns is-gapless is-centered">
      <div class="column hero is-fullheight">
        <div class="hero-body">
          <article class="is-rounded">
            <form novalidate @submit.prevent="validateEmail">
            <div class="card-content">
              <h1 class="title">
                <router-link to="/home"><img src="/static/img/HPB-logo-on-white.svg" alt="logo"></router-link>
              </h1>
              <flash-message size="is-size-6"></flash-message>
              <br/>
              <div v-if="notificationCopy">
                <p class="copy has-text-centered">Please check your email for further instructions.</p>
              </div>
              <div v-else>
                <h2 class="has-text-centered has-text-weight-bold is-size-4">Forgot your password?</h2>
                <p class="copy has-text-centered">Enter your email address and we'll send you a link to reset your password.</p>
                <p class="control">
					<input :disabled="sending" class="input" type="email" name="email" placeholder="Email" v-model="form.email"/>
					<span v-if="form.email.length > 0">
						<span class="help is-danger" v-if="!isEmailValid()">Email is not valid</span>
					</span>
			  	</p>
                <p class="control">
                  <button id="sendPasswordResetLink" type="submit"
						  :disabled="!isEmailValid()"
                          class="is-button-blue"
						  :class="[{ 'is-loading': sending}, 'button', 'is-fullwidth', 'is-size-7', 'is-uppercase', 'has-text-weight-bold']">Send Password Reset Link</button>
                </p>
              </div>
              <p class="control has-text-centered is-size-7">
                <router-link to="/login" class="is-color-31AAE1">Sign in now</router-link>
              </p>
            </div>
            </form>
          </article>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef */
  import ApiResource from '../../api/ApiResource'
  import FlashMessage from '../../components/FlashMessageStrip'
  import MiscFuncs from './../../mixins/misc.js'

  export default {
    metaInfo: {
      title: 'Business Portal | Hellopeter - Forgot Password',
      meta: process.env.NODE_ENV === 'production' ? [
        {
           'name': 'google-site-verification',
           'content': 'PGI8Df1akrJLYTmKQbUvveOzq-oORVhABnox7YB30zE'
        }
      ] : []
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Forgot Password'
      })
    },
    components: {
      FlashMessage
    },
    mixins: [MiscFuncs],
    data () {
      return {
        sending: false,
        notificationCopy: false,
        email: '',
        form: new ApiResource({
          email: ''
        })
      }
    },
    watch: {
      notificationCopy () {
        if (this.notificationCopy) {
          flash('Your password reset link has been sent.', 'is-success', true)
        }
      }
    },
    methods: {
      validateEmail () {
        if (this.isEmailValid) {
          this.sending = true
          this.form.send(`/forgot-password`, {email: this.form.email})
            .then(() => {
              this.sending = false
              this.notificationCopy = true
            })
            .catch(() => {
              this.sending = false
              flash(this.form.errors.get('email'), 'is-danger')
            })
        }
      },
      isEmailValid () {
        return this.form.email.length > 0 && this.verifyEmail(this.form.email)
      }
    }
  }
</script>

<style scoped>
  .title:not(:last-child) {
    margin-bottom: 0.5em;
  }
  #loginPage article {
	  max-width: 450px;
	  margin-left: auto;
	  margin-right: auto;
	  box-shadow: none;
  }

  #loginPage input {
	  border-radius: 0 !important;
	  border: 1px solid #dbdbdb !important;
	  box-shadow: none !important;
	  height: 3em;
  }

  #loginPage .control {
	  margin-top: 30px;
  }

  #loginPage button {
	  border: 0;
	  border-radius: 0;
	  height: 3em;
  }

  #loginPage a.VuePassword__Toggle {
	  color: gray !important;
  }

  @media screen and (max-width: 768px) {
	  #loginPage .column:not(:first-child) p {
		  padding-left: 1rem;
		  padding-right: 1rem;
	  }
  }

  h2 {
	  margin-bottom: 15px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/auth/ForgotPassword.vue